export type SvgEl = React.HTMLAttributes<HTMLOrSVGElement>;

export const IconFacebook: React.FC<SvgEl> = (props: SvgEl) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 80" {...props}>
      <path d="M8.4 80h16.1V39.7h11.3L37 26.2H24.5v-7.7c0-3.2.7-4.5 3.8-4.5H37V0H25.8C13.8 0 8.4 5.3 8.4 15.4v10.8H0v13.7h8.4z" />
    </svg>
  );
};
